import packageJson from '../../package.json';
export const environment = {
    gaMeasurementId: "",
    production: true,
    endPoints: {
        api: "https://rlgl-dev.bluecroco.com/api/1.0/",
        socketServer: "https://rlgl-dev.bluecroco.com/hubs/1.0"
    },
    sentryConfig: {
        url: "https://bdeaa767b61b106ea64c69f833ef3565@o4506308304764928.ingest.sentry.io/4506308322131968",
        environment: "develop",
        version: packageJson.version
    }
};
